import {
  Button,
  Card,
  Container,
  Grid,
  IconButton,
  Stack,
  Tooltip,
  Typography
} from "@mui/material";
import React, { useEffect, useState } from "react";
import SendTypeInsertUpdateModal from "./sendTypeInsertUpdateModal";
import { stockOutSendType } from "src/api/commonapi";
import DataTable from "react-data-table-component";
import { DeleteSharp, EditSharp } from "@mui/icons-material";
import Deletemodal from "src/pages/DeleteModal";
import { notification } from "src/utils/messages";
import CustomLoader from "src/commonComponents/CustomLoader";

export default function Index() {
  const [addEditModal, setAddEditModal] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState({ mval: false, id: 0 });
  const [modalType, setModalType] = useState("Add");
  const [sendTypeList, setSendTypeList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [rowData, setRowData] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const toggleAddEditModal = () => setAddEditModal(!addEditModal);

  const handleGetSendType = async () => {
    setIsLoading(true);
    const resp = await stockOutSendType({ method: 4 });
    setIsLoading(false);
    if (resp.status == 1) {
      setSendTypeList(resp?.data);
    }
  };

  const handleDeleteSendType = async () => {
    const resp = await stockOutSendType({
      method: 3,
      s_type_id: rowData.s_type_id
    });
    let notify = notification({
      type: resp.status == 0 ? "error" : "success",
      message: resp.message
    });
    notify();
    if (resp.status) handleGetSendType();
    setOpenDeleteModal({ mval: false, id: 0 });
  };

  useEffect(() => {
    handleGetSendType();
  }, []);

  const columns = [
    {
      name: "No",
      selector: (row, index) => (page - 1) * rowsPerPage + index + 1,
      wrap: true,
      width: "100px",
      sortable: false // Optional: disable sorting since it's just serial numbers
    },
    {
      name: "Send Type",
      wrap: true,
      selector: (row) => row.type_name,
      sortable: true
    },
    {
      name: "Action",
      wrap: true,
      sortable: true,
      width: "200px",
      selector: (row) => (
        <>
          <Tooltip title="Edit Send Type">
            <IconButton
              onClick={() => {
                setModalType("Edit");
                setRowData(row);
                toggleAddEditModal();
              }}
            >
              <EditSharp color="warning" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Delete Send Type">
            <IconButton
              onClick={() => {
                setRowData(row);
                setOpenDeleteModal({
                  mval: true,
                  id: row.s_type_id
                });
              }}
            >
              <DeleteSharp color="error" />
            </IconButton>
          </Tooltip>
        </>
      )
    }
  ];

  return (
    <>
      <Container>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
              <Typography variant="h4" gutterBottom>
                Send Type
              </Typography>
            </Stack>
          </Grid>
          <Grid item xs={6}>
            <Button
              onClick={() => {
                toggleAddEditModal();
                setModalType("Add");
              }}
              style={{ marginBottom: "15px", float: "right" }}
              variant="contained"
            >
              {/* Add Send Type */}
              Add Send Type
            </Button>
          </Grid>
        </Grid>

        <Card spacing={3} style={{ padding: "10px", marginTop: "20px" }}>
          <DataTable
            pagination
            highlightOnHover
            paginationServer={false}
            onChangePage={(p) => setPage(p)}
            paginationDefaultPage={page}
            paginationPerPage={rowsPerPage}
            onChangeRowsPerPage={(newPerPage, page) => {
              setRowsPerPage(newPerPage);
              setPage(page);
            }}
            columns={columns}
            data={sendTypeList != null ? sendTypeList : []}
            progressPending={isLoading}
            progressComponent={<CustomLoader />}
          />
        </Card>
      </Container>
      {addEditModal && (
        <SendTypeInsertUpdateModal
          addEditModal={addEditModal}
          setAddEditModal={setAddEditModal}
          modalType={modalType}
          toggleAddEditModal={toggleAddEditModal}
          rowData={rowData}
          handleGetSendType={handleGetSendType}
        />
      )}

      <Deletemodal
        visible={openDeleteModal}
        setVisible={setOpenDeleteModal}
        deletefunc={handleDeleteSendType}
      />
    </>
  );
}
